/* eslint-disable no-unused-vars */
const { getWeightEntries } = require("@/services/UserService");

function getWeeksInMonth(year, month) {
    const weeks = [];
    const firstDate = new Date(year, month - 1, 1);
    const lastDate = new Date(year, month, 0);
    const numDays = lastDate.getDate();

    let dayOfWeekCounter = firstDate.getDay();

    for (let date = 1; date <= numDays; date++) {
        if (dayOfWeekCounter === 0 || weeks.length === 0) {
            weeks.push([]);
        }
        weeks[weeks.length - 1].push(date);
        dayOfWeekCounter = (dayOfWeekCounter + 1) % 7;
    }

    return weeks
        .filter((w) => !!w.length)
        .map((w) => ({
            start: w[0],
            end: w[w.length - 1],
            dates: w.map((day) => ({ day, weight: null, weightChange:null })),
            startWeight: null,
            endWeight: null,

        }));
}

function getAllWeeks(year) {
    let months = {
        "1": { month: [], weightStart: null, weightEnd: null, },
        "2": { month: [], weightStart: null, weightEnd: null, },
        "3": { month: [], weightStart: null, weightEnd: null, },
        "4": { month: [], weightStart: null, weightEnd: null, },
        "5": { month: [], weightStart: null, weightEnd: null, },
        "6": { month: [], weightStart: null, weightEnd: null, },
        "7": { month: [], weightStart: null, weightEnd: null, },
        "8": { month: [], weightStart: null, weightEnd: null, },
        "9": { month: [], weightStart: null, weightEnd: null, },
        "10": { month: [], weightStart: null, weightEnd: null, },
        "11": { month: [], weightStart: null, weightEnd: null, },
        "12": { month: [], weightStart: null, weightEnd: null, },
    }



    for (let i = 1; i <= 12; i++) {
        let _weeksInMonth = getWeeksInMonth(year, i);

        months[i].month.push(_weeksInMonth);
    }


    return months;
}

function changeOperatorsAndRound(number) {

    let result = number * -1;
  
    result = Math.round(result * 100) / 100;
  
    return result
  
  }


//NEEDS OPTIMALIZATION
function fillDatesEntries(entries, arrayYear) {
    

    for (let month in entries){
        let entriesMonth = entries[month];

       
        arrayYear[month].weightStart = entriesMonth[0].weight; // Get first weight in an array.
        arrayYear[month].weightEnd = entriesMonth[entriesMonth.length -1].weight; // Get last object in array, if same there is no weight difference.

      
        
        entriesMonth.forEach(entry => {
            const parts = entry.date.split('-');
          
            if (parts.length === 3) {
    
    
                let monthArray = arrayYear[month].month;

                if(monthArray[0].weightStart == null){
                    monthArray[0].weightStart = entries[month]
                }
    
                monthArray[0].forEach(week => {
                    let daysWithWeightMonth = [];
    
                    let daysWithWeightWeek = [];

                    week.dates.forEach(day => {
    
                        if (day.day === parseInt([parts[0]])) {
                            day.weight = entry.weight;
                            day.weightChange = parseFloat(entry.weightChange);
                             

                            
                            
                        }
                    })
    
                    daysWithWeightWeek = week.dates.filter(week => week.weight !== null);
    
                    if (daysWithWeightWeek.length >= 1) {
                        daysWithWeightMonth.push(daysWithWeightWeek[0])
    
                        week.startWeight = daysWithWeightWeek[0].weight;
                        week.endWeight = daysWithWeightWeek[daysWithWeightWeek.length - 1].weight;
    
                    }
    
    
                })
    
    
    
    
    
            }
        })
    
     
    }
    

}

async function getCleanTableOfEntries() {
    try {
        let entries = await getWeightEntries();
        entries = entries.data;

        // Custom comparison function for sorting by date
        const sortByDate = (a, b) => {
            const dateA = new Date(a.date.split('-').reverse().join('-'));
            const dateB = new Date(b.date.split('-').reverse().join('-'));
            return dateA - dateB;
        };

        // Sorting the entries array by date
        entries.sort(sortByDate);

        for (let i = 0; i < entries.length; i++){
            if (i > 0) {
                // Calculate weight change as the difference from the previous entry
                entries[i].weightChange = (entries[i].weight - entries[i - 1].weight).toFixed(2)
             
            }
        }
        
        return entries;
 
    } catch (error) {
        console.error('Error fetching or processing weight entries:', error);
    }
}

async function sortedYearWeightEntries() {

    let entries = await getCleanTableOfEntries();
 


    let yearEntries = {};

    entries.forEach(entry => {
        const parts = entry.date.split('-');
        if (parts.length === 3) {
            const year = parseInt(parts[2]);
            const month = parseInt(parts[1]);

            if (!yearEntries[year]) {
                yearEntries[year] = {};
            }

            let yearEntry = yearEntries[year];
            if (!yearEntry[month]) {
                yearEntry[month] = [];
            }

            yearEntry[month].push(entry);
            

            yearEntry[month].sort((a, b) => {
                const dateA = new Date(a.date.split('-').reverse().join('-'));
                const dateB = new Date(b.date.split('-').reverse().join('-'));
                return dateA - dateB;
            });


            
        }
    });
   

    return yearEntries;

}

function getPercentProgress(weightStart, currentWeight, goal) {


    const weightLoss = weightStart - currentWeight;
    const percentProgress = (weightLoss / (weightStart - goal)) * 100;
    return percentProgress.toFixed(2) + "%";
}

function calculateBodyMassIndex(weight, height, system) {

    if (system === 0) {
        return 0;
    }
    const kilograms = weight;
    const meters = height / 100;
    const bmi = kilograms / (meters * meters);

    return bmi.toFixed(2);
  }

exports.utils = { getAllWeeks, getWeeksInMonth, sortedYearWeightEntries, fillDatesEntries, changeOperatorsAndRound,getCleanTableOfEntries, getPercentProgress,  calculateBodyMassIndex }